import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrSupportUserType.ts
var t = () => e("supportUserType");
//#endregion
export { t as useTrSupportUserType };
